import React, { useState, useEffect } from "react";
import { Button, Form, Message } from "semantic-ui-react";
import firebase from "firebase";
import {
  validatePassword,
  errorMsgs,
} from "../../../../commons/functions/formValidations";
import "./styles.css";

const ChangePassword = () => {
  const INITIAL_PAYLOAD = {
    newPassword: "",
    checkPassword: "",
  };
  const [payload, setPayload] = useState(INITIAL_PAYLOAD);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isValid, setIsValid] = useState({
    newPassword: { valid: true, error: "" },
    checkPassword: { valid: true, error: "" },
  });
  useEffect(() => {
    const isValidForm = Object.values(isValid).every((element) =>
      Boolean(element.valid)
    );
    if (
      payload.newPassword === payload.checkPassword &&
      isValidForm &&
      payload.newPassword.length > 0
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [payload, isValid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    switch (name) {
      case "newPassword":
      case "checkPassword":
        validatePassword(value)
          ? validateForm(name, true, "")
          : value === ""
          ? validateForm(name, false, errorMsgs.required)
          : validateForm(name, false, errorMsgs.password);
        break;
      default:
        break;
    }
  };
  const validateForm = (name, bool, error) => {
    setIsValid((prevState) => ({
      ...prevState,
      [name]: { valid: bool, error },
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSuccess(false);
      setError("");
      setLoading(true);
      await firebase.auth().currentUser.updatePassword(payload.newPassword);
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="change-password-container">
      <Form
        loading={loading}
        error={Boolean(error)}
        onSubmit={handleSubmit}
        success={success}
      >
        <Message
          success
          icon="check"
          header="¡Éxito!"
          content="Su contraseña ha sido actualizada."
        />
        <Message error header="Oops!" content={error} />
        <Form.Field>
          <Form.Input
            className="change-password-input"
            label="Nueva Contraseña"
            placeholder="Nueva contraseña"
            name="newPassword"
            onChange={handleChange}
            value={payload.newPassword}
            type="password"
          />
          <p className="change-password-input-error">
            {!isValid.newPassword.valid && isValid.newPassword.error}
          </p>

          <Form.Input
            className="change-password-input"
            label="Verificar contraseña"
            placeholder="Verificar contraseña"
            name="checkPassword"
            onChange={handleChange}
            value={payload.checkPassword}
            type="password"
          />
          <p className="change-password-input-error">
            {!isValid.checkPassword.valid && isValid.checkPassword.error}
          </p>

          <div className="text-center">
            {payload.newPassword !== payload.checkPassword ? (
              payload.checkPassword === "" ? null : (
                <p className="signup-password-error">
                  Las contraseñas no coinciden
                </p>
              )
            ) : (
              payload.newPassword === "" && payload.checkPassword === "" && null
            )}
          </div>
        </Form.Field>

        <Button
          type="submit"
          color="black"
          content="Cambiar contraseña"
          disabled={disabled || loading}
        />
      </Form>
    </div>
  );
};

export default ChangePassword;
